import {ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { EntityDataLayoutService } from "./entity-data-layout.service";
import {distinctUntilChanged, map } from 'rxjs';
import {EntityKeyService} from "@pma-entity/services/entity-key.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'entity-data-layout',
  templateUrl: './entity-data-layout.component.html'
})
export class EntityDataLayoutComponent
  implements OnInit {

  readonly viewName$ = this.entityDataLayoutService.ViewName$;
  readonly entityKey$ = this.entityDataLayoutService.EntityKey$;
  readonly dashboardTitle$ = this.entityDataLayoutService.DashboardTitle$;
  readonly ref$ = this.entityDataLayoutService.Ref$;
  readonly maximisedWidget$ = this.entityDataLayoutService.MaximisedWidget$;
  readonly routeContextTypeName$ = this.entityDataLayoutService.ActivatedRoute$.pipe(
    map(route => route.snapshot?.data?.routeContext?.kind),
    distinctUntilChanged()
  );

  constructor(
    private readonly entityDataLayoutService: EntityDataLayoutService,
    private readonly entityKeyService: EntityKeyService) {
  }

  /**
   * @remarks
   *
   * the first time this component is loaded means that dashboards and listers are being entered
   * from 'outside' i.e. previous overview is not being retained, which means we have to start
   * with the top level overview after this first init (ngOnInit will not run again until
   * the route navigates outside the reused entity-data route scope (see MojoRouteReuseStrategy).
   * Whilst navigating within the route reuse scope (entity-data urls) route navigation event
   * handling responds to entity key i.e. overview level changes.
   */
  ngOnInit(): void {
    this.entityKeyService.setEmptyEntityKey();
  }

}
